import axios from "axios";
import store from '@/store';
import { Service } from 'axios-middleware';
const service = new Service(axios);
import router from "@/router";

import getAccessToken from "@/helper/getAccessToken";
import requestErrorHandling from "@/helper/requestErrorHandling";
import { getExistingPath } from "@/services/http-client/helper";
import { baseURL } from "@/helper";

const httpClient = axios.create({
	baseURL,
	headers: {
		"Content-Type": "application/json"
	}
});

service.register({
	async onRequest(config) {
		const isForbiddenPaths = getExistingPath(config.url);

		if (!(isForbiddenPaths)) {
			const pathName = router.currentRoute.name;
			await store.dispatch('onLogin', pathName);
		}
		return config;
	}
});

const authInterceptorRequest = (config) => {
	const token = getAccessToken();
	config.headers["Authorization"] = token;

	return config;
};

const authInterceptorResponse = response => response;
const interceptorResponseRejected = error => requestErrorHandling(error);

httpClient.interceptors.request.use(authInterceptorRequest);
httpClient.interceptors.response.use(authInterceptorResponse, interceptorResponseRejected);

export default httpClient;
